export default function PageHeader({ children }) {
  const dataBookBorrow = localStorage.getItem('isBorrowBookInfo')
  const isListUserPerBookBorrowPage = dataBookBorrow ? true : false
  return (
    <h1
      className={`truncate text-nowrap pr-8 ${isListUserPerBookBorrowPage ? `text-end text-2xl` : `text-3xl`} font-bold text-gray-accent hover:underline`}
      title={children}
    >
      {children}
    </h1>
  )
}
